import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "label", "checked", "defaultChecked", "disabled", "onChange", "inputRef", "tabIndex", "name", "id", "autoFocus", "children", "invalid", "value", "role", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { generateDataTestId } from '../../utils';
import { HiddenInput } from '../HiddenInput';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ControlInputContainer = /*#__PURE__*/React.forwardRef(function ControlInputContainer(props, ref) {
  const {
      type,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      label,
      checked,
      defaultChecked,
      disabled,
      onChange,
      inputRef,
      tabIndex,
      name,
      id,
      autoFocus,
      children,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      invalid,
      value,
      role,
      dataTestId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const handleChange = e => {
    if (onChange) {
      onChange(e, e.currentTarget.checked);
    }
  };
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(rest.className, styles['container']),
    ref: ref,
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(HiddenInput, _objectSpread(_objectSpread({}, value && {
      value
    }), {}, {
      type: type,
      ref: inputRef,
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      onChange: handleChange,
      tabIndex: tabIndex,
      name: name,
      id: id,
      autoFocus: autoFocus,
      role: role,
      "data-testid": generateDataTestId(dataTestId, ['input'])
    })), children]
  }));
});